'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _reactRouter = require('react-router');

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _ElementConnectionsContextProvider = require('../components/connections/components/ElementConnectionsContextProvider');

var _ElementConnectionsContextProvider2 = _interopRequireDefault(_ElementConnectionsContextProvider);

var _MeasurementsProvider = require('../components/measurements/MeasurementsProvider');

var _MeasurementsProvider2 = _interopRequireDefault(_MeasurementsProvider);

var _EditorStoreProvider = require('../components/editor/store/components/EditorStoreProvider');

var _EditorStoreProvider2 = _interopRequireDefault(_EditorStoreProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Element connections


/**
 * The root component of the application.
 *  - Sets up the Redux Provider (which allows container components to access the store).
 *  - Configures the Router (from React Router).
 *
 * This component requires:
 *  - store (redux store)
 *  - history (the react-router-redux wrapped browserHistory instance)
 */
var Root = function (_React$Component) {
    _inherits(Root, _React$Component);

    function Root() {
        _classCallCheck(this, Root);

        return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
    }

    _createClass(Root, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                store = _props.store,
                history = _props.history,
                measurementsStore = _props.measurementsStore,
                elementConnectionsManager = _props.elementConnectionsManager,
                editorStore = _props.editorStore;


            return _react2.default.createElement(
                _ElementConnectionsContextProvider2.default,
                { manager: elementConnectionsManager },
                _react2.default.createElement(
                    _EditorStoreProvider2.default,
                    { store: editorStore },
                    _react2.default.createElement(
                        _MeasurementsProvider2.default,
                        { store: measurementsStore },
                        _react2.default.createElement(
                            _reactRedux.Provider,
                            { store: store },
                            _react2.default.createElement(
                                _reactDocumentTitle2.default,
                                { title: 'Milanote' },
                                _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default, store: store })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Root;
}(_react2.default.Component);

exports.default = Root;


Root.propTypes = {
    elementConnectionsManager: _propTypes2.default.object.isRequired,
    editorStore: _propTypes2.default.object.isRequired,
    measurementsStore: _propTypes2.default.object.isRequired,
    store: _propTypes2.default.object.isRequired,
    history: _propTypes2.default.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/client/app/Root.js
// module id = 1668
// module chunks = 0